import './common_index';

import React from 'react';
import ReactDOM from 'react-dom';

import Chrome from './components/frontend/chrome';
import App from './components/frontend/app';
import {StateProvider} from './components/generic';
import * as frontend from './components/frontend';
import * as generic from './components/generic';

// Leverage Tree Shaking to keep admin code out
// of the frontend and frontend code out of the admin.
polyphony.components = {frontend,generic};
polyphony.render = () => ReactDOM.render(
    <StateProvider className="blog">
        <Chrome />
        <App />
    </StateProvider>, document.getElementById("content"));

//
// Load the content
//
polyphony.loadContent();

